import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useT } from "../../../core/i18n";

const IDCardInstruction: React.FC = () => {
  const { t } = useT();
  const routes = all_routes;
  const navigate = useNavigate();

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">{t("Instruction")}</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.employeeDashboard}>{t("home") || "Home"}</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={routes.services.list}>{t("services") || "Services"}</Link>
                </li>
                <li className="breadcrumb-item active">{t("Instruction")}</li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="card border-0 shadow-sm">
          <div className="card-body p-4">
            <p className="lh-lg">{t("DMRC_ID_Card_Instruction")}</p>
            <p className="lh-lg">{t("DMRC_ID_Card_Instruction_Hindi")}</p>
            <p className="text-danger fw-semibold">{t("Note_Old_ID_Card")}</p>
            <p className="text-danger fw-semibold">{t("Note_Old_ID_Card_Hindi")}</p>
            <div className="text-center mt-4">
              <button type="button" className="btn btn-danger px-5" onClick={() => navigate(routes.idCard.list)}>
                {t("next") || t("Next")}
                <i className="ti ti-arrow-right ms-2" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IDCardInstruction;
